<template>
  <div>
    <div class="headerTabs">
      <el-tabs class="tabs" stretch v-model="tabIndex" @tab-click="handleClick">
        <el-tab-pane :label="item.keyName" :name="item.keyValue" v-for="(item, index) in tableData" :key="index">
          <template v-if="index !== 2">
            <div class="scrDiv" v-infinite-scroll="load" style="overflow:auto" :infinite-scroll-distance="20">
              <div class="item" v-for="(item, index) in listData" :key="index" @click="open(item)">
                <div class="titles">
                  <img :src="item.imgUrl" mode="">
                  <div class="title">
                    {{ item.title }}
                  </div>
                </div>
                <div class="cont">
                  {{ item.content }}
                </div>
                <div class="time">
                  <!-- {{ item.createTime }} -->
                  {{ item.gzhDate }}
                </div>
              </div>
              <div class="btnView"></div>
            </div>

          </template>
          <template v-else>
            <div class="videos">
              <div class="listItem" v-for="(item, index) in videoList">
                <video style="width: 100%;" :src="item.url" :ref="'video' + index" controls :poster="item.imgUrl"></video>
                <div class="videoName">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </template>

        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import cfg from "@/utils/config.js"
import { getInformationList, getCommonDataList } from "@/api/news"
export default {
  data () {
    return {
      showImg: false,
      tabIndex: '',
      list: [],
      contList: [],
      value: "",
      show: true,
      tableData: [],
      listData: [],
      pageNum: 1,
      videoList: []

    };
  },
  mounted () {
    this.pageNum = 1;
    this.listData = [];
    this.tabIndex = ''
    getCommonDataList({ commonData: 'information', isRelease: this.$store.state.editStatus }).then(res => {
      this.tableData = res.data;
      // axios.get(cfg.fileUrl+'/ycxxFileUrl/wxapplet/videos/video.json').then(res => {
      //     this.tableData.push({ keyName: '视频分享', keyValue: '3' })
      //     this.videoList = res.data.list

      // })

      this.tabIndex = res.data[0].keyValue;
      this.getList();
    })
  },
  methods: {
    load (e) {
      if (this.pageNum > 1) {
        this.getList();

      }

    },
    getList () {
      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
        type: this.tabIndex,
        isRelease: this.$store.state.editStatus

      }
      getInformationList(params).then(res => {
        this.total = res.data.total;
        if (res.data.list.length > 0) {
          this.pageNum++;
          this.listData = this.listData.concat(res.data.list)
        }


      })
    },
    collapseChange () {

    },
    handleClick (e) {
      this.pageNum = 1;
      this.listData = [];
      this.tabIndex = (Number(e.index) + 1) + '';
      this.getList();
    },
    open (data) {
      let url = data.detailUrl



      if (url.indexOf('pdf') > -1) {
        let d = new Date()
        this.$router.push({ path: '/pdfFile', query: { name: url, url: '', type: this.tabIndex, t: d.getTime() } });
      } else if (url.indexOf('<p>') > -1) {
        this.$store.commit('setHtmlCont', data)
        this.$router.push({ path: '/newsDetail' })

      } else {
        window.open(url);
      }


    },
    clickTab (e) {
      this.tabIndex = e.index
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 100)
    },
    showImage (data) {
      let urls = [];
      data.forEach(e => {
        urls.push(e.img)
      })
      uni.predivImage({
        urls: urls,
        current: data.img
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .u-tabs__wrapper__nav__item__text {
  font-size: 28px !important;
}

.tabsLine {
  border-bottom: 1px solid #ddd;
  margin-top: -6px;
}

.item {
  margin-bottom: 20px;
  padding: 30px 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #f8f8f8;

  .titles {
    display: flex;

    img {
      width: 157px;
      height: 80px;
      margin-right: 40px;
    }

    .title {
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #1b1b1b;
      line-height: 39px;
      text-align: left;
    }
  }

  .cont {
    margin-top: 36px;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #8e8e8e;
    line-height: 39px;
    text-indent: 2em;
    text-align: left;
  }

  .time {
    text-align: right;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #8e8e8e;
    margin-top: 34px;
  }
}

::v-deep .tabs {
  position: fixed;
  top: 0;
  width: 100%;

  .el-tabs__header {
    margin-bottom: 10px;
    background-color: #fff;

    .el-tabs__nav-wrap {
      padding: 0 20px;
    }
  }

  .el-tabs__item {
    height: 90px;
    line-height: 90px;
    font-size: 28px;
  }

  .el-collapse-item__header {
    height: 90px;

    .title {
      display: flex;
      align-items: center;
      padding: 0 20px;
      font-size: 28px;

      img {
        width: 50px;
      }

      span {
        margin-left: 20px;
      }
    }
  }
}

.videos {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 50% 50%;
  border-radius: 8px;
  overflow: hidden;
  padding: 20px;
  // 行列间距
  column-gap: 20px;
  row-gap: 20px;

  .listItem {
    box-sizing: border-box;

    video {
      width: 100%;
    }

    .videoName {
      font-size: 24px;
      color: #666;
    }
  }
}
</style>